import { defineComponent, computed } from "vue";
import LinkButton from "./component-library3.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "arrow",
  props: {
    direction: {
      type: String,
      default: "left",
      validator(value) {
        return ["left", "right", "top", "bottom"].includes(value);
      }
    },
    setPosition: {
      type: Boolean
    },
    tag: {
      type: String,
      default: "button"
    }
  },
  emits: { change: (direction) => direction },
  setup(__props) {
    const props = __props;
    const isLink = computed(() => ["button", "nuxt-link", "a"].includes(props.tag));
    const component = computed(() => isLink.value ? LinkButton : props.tag);
    return { __sfc: true, props, isLink, component };
  }
});
export {
  _sfc_main as default
};
